<template>
  <div class="sc-video">
    <div class="container">
      <h2 class="sc-title -small-margin">Využi potenciál tímu</h2>
      <p class="sc-lead">
        Vieme, že spolu nám to ide najlepšie a každý jednotlivec v tíme je pre nás dôležitý. Pridáš sa k nám aj ty?
      </p>
      <div class="sc-video-wrapper">
        <iframe
          class="sc-video-embed"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/RfhDmsLfprQ?controls=0"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <div class="sc-video-background"></div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.sc-video {
  padding: 50px 0;
  text-align: center;
  position: relative;
  @media screen and (min-width: $screen-md) {
    padding: 30px 0 150px;
  }
  .sc-video-wrapper {
    display: block;
    position: relative;
    max-width: 900px;
    margin: 20px auto 0;
    &::before {
      content: "";
      display: block;
      padding-top: 56.25%;
    }
    @media screen and (min-width: $screen-md) {
      margin: 120px auto 0;
    }
  }
  .sc-video-embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .sc-video-background {
    position: absolute;
    z-index: -1;
    top: 150px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $primary-faded;
    background-image: url('../assets/sc/pattern-video.svg');
    background-size: contain;
    clip-path: polygon(0 0, 100% 20%, 100% 100%, 0 80%);
    @media screen and (min-width: $screen-md) {
      top: 25%;
    }
  }
}
</style>
